"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[786],{

/***/ 1786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ tkyfOptScreen_OptScreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/button/Button.tsx + 2 modules
var Button = __webpack_require__(8106);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
// EXTERNAL MODULE: ./node_modules/react-loading-icons/dist/esm/index.js + 12 modules
var esm = __webpack_require__(5533);
;// CONCATENATED MODULE: ./components/widgets/tkyfOptScreen/OptScreen.tsx

/* eslint-disable @next/next/no-img-element */ 





var OptScreen = function(param) {
    var title = param.title, logo = param.logo, desc = param.desc;
    var ref = (0,react.useState)(''), phoneData = ref[0], setPhoneData = ref[1];
    var ref1 = (0,react.useState)(), createData = ref1[0], setcreateData = ref1[1];
    var ref2 = (0,react.useState)(false), isCorrect = ref2[0], setIsCorrect = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(false), phoneErr = ref4[0], setPhoneErr = ref4[1];
    var app = (0,contexts_app/* useApp */.qD)();
    var phoneServiceCreate = function() {
        var formatPhone = phoneData.replace(/\s/g, '');
        var postData = {
            columns: [
                {
                    name: 'phoneNumber',
                    data: {
                        refs: [
                            'string'
                        ],
                        value: formatPhone
                    }
                }, 
            ]
        };
        if ((formatPhone === null || formatPhone === void 0 ? void 0 : formatPhone.length) === 11) {
            setIsLoading(true);
            setPhoneErr(false);
            axios_default().post('https://integration-api.tga.gov.tr/suggestionuserv2/create-otp', postData).then(function(response) {
                localStorage.setItem('userPhone', formatPhone);
                setcreateData(response.data);
            }).catch(function(error) {
                setIsLoading(false);
                console.log(error);
            });
        } else {
            setPhoneErr(true);
        }
    };
    (0,react.useEffect)(function() {
        if (createData) {
            window.location.href = "otp-page";
            setIsCorrect(true);
        }
    }, [
        createData
    ]);
    var handlePhoneChange = function(e) {
        var enteredValue = e.target.value.replace(/([()])/g, '').replace(/ /g, '');
        if (enteredValue) {
            if (enteredValue[0] === '0') {
                var groups = [
                    enteredValue.slice(0, 4),
                    enteredValue.slice(4, 7),
                    enteredValue.slice(7, 11), 
                ];
                setPhoneData(groups.filter(function(group) {
                    return group;
                }).join(' '));
            }
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "form background-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "form_container",
            style: {
                maxWidth: '400px'
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            md: {
                                size: 12
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form_logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://cdn.tga.net.tr/".concat(logo === null || logo === void 0 ? void 0 : logo.src),
                                    alt: "",
                                    width: (logo === null || logo === void 0 ? void 0 : logo.width) || 200,
                                    height: logo === null || logo === void 0 ? void 0 : logo.height
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            md: {
                                size: 12
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form_title",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            desc,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            md: {
                                size: 12
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form_phone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    placeholder: "0-599-999-99-99",
                                    value: phoneData,
                                    onChange: handlePhoneChange
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    textAlign: 'center',
                                    marginTop: '50px'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Rings */._P, {
                                    stroke: "#4a90e2",
                                    strokeWidth: 4
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form_button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: phoneData.length !== 13 ? true : false,
                                    appearance: "default",
                                    onClick: function() {
                                        phoneServiceCreate();
                                    },
                                    children: "Doğrulama Kodu G\xf6nder"
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var tkyfOptScreen_OptScreen = (OptScreen);

;// CONCATENATED MODULE: ./components/widgets/tkyfOptScreen/index.ts



/***/ })

}]);